<template>
  <div class="user-item">
    <div class="user--base-info">
      <el-avatar :size="50" :src="getUserAvatar(account)">
        {{ computedUserName }}
      </el-avatar>
      <span class="fullname">{{ fullname }}</span>
      <span class="account">{{ account }}</span>
    </div>
    <div class="user--dept">
      <i class="el-icon-link" />

      <span>{{ pathname || '--' }}</span>
    </div>
    <div class="user--leader">
      <i class="el-icon-s-custom" />

      <span>{{ $t('eip.nav.leader') }}:</span>
      <el-avatar :size="18" :src="getUserAvatar(superiorId)">
        {{ computedLeaderName }}
      </el-avatar>
      <span class="fullname">{{ superiorName || '--' }}</span>
    </div>
    <div class="user--operate">
      <el-button type="success" size="small" @click="handleCommunicate">
        {{ $t('eip.nav.communicate') }}
      </el-button>
    </div>
  </div>
</template>

<script>
  import { getUserAvatar } from '@/utils/index'
  import { getOpenId } from '@/api/user'

  const getName = (userName) => {
    if (!userName) return ''

    // 汉字正则
    const zhCharReg = /[\u4E00-\u9FA5]/

    if (zhCharReg.test(userName)) return userName?.slice(-4)

    // 英文名，首字母大写
    return userName.length <= 4
      ? userName
      : userName
          .split(' ')
          .map((name) => name[0]?.toUpperCase())
          .join('')
  }

  export default {
    name: 'HtUserCard',
    props: {
      user: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        getUserAvatar,
        computedUserName: getName(this.user.fullname),
        computedLeaderName: getName(this.user.superiorName),
        superiorName: this.user.superiorName,
        fullname: this.user.fullname,
        account: this.user.account,
        superiorId: this.user.superiorId,
        pathname: this.user.pathname,

        isProd: process.env.VUE_APP_ENV === 'prod',
      }
    },

    methods: {
      async handleCommunicate() {
        if (!this.isProd) {
          this.$message.warning(this.$t('eip.nav.prohibitedCommunication'))
          return
        }

        try {
          const { data, message } = await getOpenId(this.account)

          if (!data) {
            this.$message.error(message)
            return
          }

          window.window.open(
            `https://applink.feishu.cn/client/chat/open?openId=${data}`,
            '_blank'
          )
        } catch (e) {
          console.log(e)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .user-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    padding: 0 15px;
    margin-bottom: 15px;
    font-size: 13px;
    color: rgb(75, 85, 99);
    border-radius: 10px;
    box-shadow: 0 0 10px 1px rgba($color: #000000, $alpha: 0.05);
    transition: box-shadow 0.3s ease-in-out;

    & > div:last-child {
      text-align: right;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      box-shadow: 0 0 10px 1px rgba($color: #000000, $alpha: 0.1);
    }

    .user--base-info,
    .user--dept,
    .user--leader {
      display: flex;
      flex: 1;
      align-items: center;

      i {
        margin-right: 4px;
      }
    }

    .user--base-info {
      .el-avatar {
        flex: none;
      }

      .fullname {
        font-size: 16px;
        font-weight: bold;
      }

      span {
        margin-left: 4px;
      }
    }

    .user--leader {
      .el-avatar {
        margin: 0 4px;
      }
    }

    .user--operate {
      flex: none;
    }
  }
</style>
